import React, { ChangeEvent, ReactElement } from 'react'
import useStyles from './checkbox.styles'
import clsx from 'clsx'

interface Props {
  label?: ReactElement | string
  className?: string
  name?: string
  checked?: boolean
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
  onBlur?: (e: ChangeEvent<HTMLInputElement>) => void
}

const Checkbox = React.forwardRef<HTMLInputElement, Props>(
  ({ label, className, name, checked, onChange, onBlur }, ref) => {
    const classes = useStyles()
    return (
      <div className={clsx(classes.checkboxRoot, className)}>
        <label htmlFor={name}>
          <input
            id={name}
            name={name}
            type="checkbox"
            onChange={onChange}
            onBlur={onBlur}
            data-test={name}
            ref={ref}
            checked={checked}
          />
          <span className={classes.checkmark} />
          {label && <span className={classes.label}>{label}</span>}
        </label>
      </div>
    )
  }
)

export default Checkbox
